const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const MoveEvent = require('../../events/MoveEvent');
const StandardStrike = require('../StandardStrike');
const { logError } = require('../../logger');

const Tussle = function(battleState) {
  this.handle = 'tussle';
  this.physical = true;
  this.movement = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);

      const moveEvents = [];

      const victimTile = battleState.getTileAtCoords(victim.x, victim.y);
      const moveEvent1 = new MoveEvent(battleState, actor.uid);
      moveEvent1.actorId = actor.uid;
      moveEvent1.victimId = victimTile.uid;
      moveEvents.push(moveEvent1);

      const actorTile = battleState.getTileAtCoords(actor.x, actor.y);
      const moveEvent2 = new MoveEvent(battleState, victim.uid);
      moveEvent2.actorId = victim.uid;
      moveEvent2.victimId = actorTile.uid;
      moveEvents.push(moveEvent2);

      moveEvent1.execute(victimTile);
      moveEvent2.execute(actorTile);

      setTimeout(() => {
        try {
          if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
            return { success: false };
          }

          var strike = new StandardStrike(this,battleState).execute(
            actor,
            victim,
            ability.damage,
            false,
          );

          // result
          var result = { moveEvent1,moveEvent2,strike };
          result.abilityHandle = this.handle;
          result.actorId = actor.uid;
          result.victimId = victim? victim.uid : null;
          result.allPieces = battleState.allPieces;
          this.eventEmitter.emit('result', result);
        } catch (err) {
          logError(err, {
            module: 'Tussle',
            func: 'execute(timeout)',
            actor,
            victim,
          });
          return { success: false };
        }
      }, BattleCalc.getCooldown(actor)*500);
    } catch (err) {
      logError(err, {
        module: 'Tussle',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = Tussle;
